// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReSchema from "../reform/ReSchema.bs.jsx";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function CustomValidators(Lenses) {
  let ReSchema$1 = ReSchema.Make(Lenses);
  let custom = ReSchema$1.Validation.custom;
  let email = extra => ReSchema$1.Validation.email("Neplatný email", extra);
  let equals = (expected, error, field) => ReSchema$1.Validation.custom(lensState => {
    let value = Lenses.get(lensState, field);
    if (Primitive_object.equal(value, expected)) {
      return "Valid";
    } else {
      return {
        TAG: "Error",
        _0: error
      };
    }
  }, field);
  let float = ReSchema$1.Validation.float;
  let int = ReSchema$1.Validation.int;
  let intNonZero = (errorOpt, field) => {
    let error = errorOpt !== undefined ? errorOpt : "Nesmí být nula";
    return ReSchema$1.Validation.custom(lensState => {
      let value = Lenses.get(lensState, field);
      if (value !== 0) {
        return "Valid";
      } else {
        return {
          TAG: "Error",
          _0: error
        };
      }
    }, field);
  };
  let isNumeric = (errorOpt, field) => {
    let error = errorOpt !== undefined ? errorOpt : "Musí být číslo";
    return ReSchema$1.Validation.custom(lensState => {
      let value = Lenses.get(lensState, field);
      let match = Stdlib_Float.fromString(value);
      if (match !== undefined) {
        return "Valid";
      } else {
        return {
          TAG: "Error",
          _0: error
        };
      }
    }, field);
  };
  let matchField = (secondField, error, field) => ReSchema$1.Validation.custom(lensState => {
    let value = Lenses.get(lensState, field);
    let secondFieldValue = Lenses.get(lensState, secondField);
    if (Primitive_object.equal(value, secondFieldValue)) {
      return "Valid";
    } else {
      return {
        TAG: "Error",
        _0: error
      };
    }
  }, field);
  let notIn = (haystack, error, field) => ReSchema$1.Validation.custom(lensState => {
    let value = Lenses.get(lensState, field);
    if (haystack.includes(value)) {
      return {
        TAG: "Error",
        _0: error
      };
    } else {
      return "Valid";
    }
  }, field);
  let oneOf = (haystack, error, field) => ReSchema$1.Validation.custom(lensState => {
    let value = Lenses.get(lensState, field);
    if (haystack.includes(value)) {
      return "Valid";
    } else {
      return {
        TAG: "Error",
        _0: error
      };
    }
  }, field);
  let password = field => ReSchema$1.Validation.custom(lensState => {
    let value = Lenses.get(lensState, field);
    if (value.length < 6) {
      return {
        TAG: "Error",
        _0: "Heslo musí mít alespoň 6 znaků"
      };
    } else {
      return "Valid";
    }
  }, field);
  let required = extra => ReSchema$1.Validation.regExp("Bez tohoto to nepůjde", "[^\s]", extra);
  let schema = ReSchema$1.Validation.schema;
  return {
    ReSchema: ReSchema$1,
    Validation: undefined,
    custom: custom,
    email: email,
    equals: equals,
    float: float,
    int: int,
    intNonZero: intNonZero,
    isNumeric: isNumeric,
    matchField: matchField,
    notIn: notIn,
    oneOf: oneOf,
    password: password,
    required: required,
    schema: schema
  };
}

export {
  CustomValidators,
}
/* No side effect */
